import { Component, ViewEncapsulation, ElementRef, Inject } from '@angular/core';
import { slideInOutAnimation } from '@toro/common/shared/animations/slide-in-out.animation';
import { DialogPanelComponentContent } from '@toro/common/shared/models/dialogs/DialogPanelComponentContent';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
    selector: 'wallet-investment-resume',
    templateUrl: './wallet-investment-resume.component.html',
    styleUrls: ['wallet-investment-resume.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
})
export class WalletInvestmentResumeComponent extends DialogPanelComponentContent {

    public numStocks: number;
    public valueToInvest: number;
    public brockerTax: number;
    public schedule: boolean;

    public sendInvestmentSubject: Subject<boolean> = new Subject<boolean>();

    public constructor(
        @Inject(MAT_DIALOG_DATA) private data,
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<WalletInvestmentResumeComponent>,
        public router: Router,
    ) {
        super(elementRef, true);

        this.numStocks = data.numStocks;
        this.valueToInvest = data.valueToInvest;
        this.brockerTax = data.brockerTax;
        this.schedule = data.schedule;
    }

    /**
     * Envia o investimento
     */
    public sendInvestment() {
        this.closeDialog();
        this.sendInvestmentSubject.next(true);
    }

    public closeDialog() {
        this.close(this.dialogReference, null);
    }
}
